module.exports = __webpack_public_path__ + "img/7.a3f7a1d0.png";